import {isSelfService} from "./kiosk";
import moment from "moment";

export function isUpcomingAppointment({status, groupSession, participants}) {
  return status !== "PROCESSING" && status !== "PROCESSED"
    && ((groupSession && participants.every(participant => !participant.waiting))
      || (!groupSession && status !== "WAITING"));
}

export const isNotTimeoutError = (httpResponse) =>
  httpResponse.error && httpResponse.httpStatusCode && httpResponse.httpStatusCode !== 423;

const isKioskQueueEmpty = (kioskQueueSize, kioskMaxWaitTime) =>
  (kioskQueueSize === 0 && kioskMaxWaitTime === 0)
  || (kioskQueueSize === 0 && kioskMaxWaitTime === null)
  || (kioskQueueSize === null && kioskMaxWaitTime === 0)
  || (kioskQueueSize === null && kioskMaxWaitTime === null);

export const shouldDisplayWaitTime = (kioskQueueSize, kioskMaxWaitTime, kioskType) =>
  !(isKioskQueueEmpty(kioskQueueSize, kioskMaxWaitTime) || isSelfService(kioskType));

export const getWaitingTime = (kioskMaxWaitTime) => {
  const duration = moment.duration(kioskMaxWaitTime, 'minutes'); // Return a Duration object with time given in minutes
  const minutes = duration.minutes();
  const hours = duration.hours();
  const days = duration.days();
  return { minutes, hours, days };
}
